<ng-container *ngIf="alert">
    <div [class]="'vl-alert vl-alert--' + alert.type" role="alert">
        <div class="vl-alert__icon">
            <i class="vl-vi vl-vi-warning" [ngClass]="{'vl-vi-warning': alert.type === ('error' || 'warning')}"
                [ngClass]="{'vl-vi-info-circle': alert.type === ('info' || 'success')}" aria-hidden="true"></i>
        </div>
        <div class="vl-alert__content">
            <p class="vl-alert__title" *ngIf="alert?.title">{{ alert.title }}</p>
            <div class="vl-alert__message">
                <p>{{ alert.message }}</p>
            </div>
        </div>
        <button class="vl-alert__close" type="button" (click)="onClickClose()">
            <i class="vl-vi vl-vi-cross" aria-hidden="true"></i>
            <span class="vl-u-visually-hidden">Sluiten</span>
        </button>
    </div>
</ng-container>